import { render, staticRenderFns } from "./form-pc.vue?vue&type=template&id=13aecccb"
import script from "./form-pc.vue?vue&type=script&lang=ts"
export * from "./form-pc.vue?vue&type=script&lang=ts"
import style0 from "./form-pc.vue?vue&type=style&index=0&id=13aecccb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports